// import router from "../../router";
//import eventBus from "../../../main";
//import jwtDecode from "jwt-decode";

export default {
  state: {
    drawer: {
      personal: String,
      enterprise: String
    }
  },
  mutations: {
    SET_D_ENTERPRISE(state, value) {
      state.drawer.enterprise = value;
    },
    SET_D_PERSONAL(state, value) {
      state.drawer.personal = value;
    }
  },
  actions: {
    setDrawerEnterprise(context, value) {
      context.commit("SET_D_ENTERPRISE", value);
    },
    setDrawerPersonal(context, value) {
      context.commit("SET_D_PERSONAL", value);
    }
  },

  getters: {
    getDrawerEnterprise(state) {
      return state.drawer.enterprise;
    },
    getDrawerPersonal(state) {
      return state.drawer.personal;
    }
  }
};
